var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 31h17a1 1 0 0 0 1-1V12.804L23.521 5H13a1 1 0 0 0-1 1v24a1 1 0 0 0 1 1zM24.375 3 33 12v18a3 3 0 0 1-3 3H13a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h11.375z",
    fill: "#FF9811"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 4h2v9h8v2H22V4z",
    fill: "#FF9811"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 14V4h1l8 8v2h-9zM3 10h17.143v16H3z",
    fill: "#FF9811"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.288 20.143H5.146V18h2.142v2.143zm4.284 0H9.431V18h2.141v2.143zm4.285 0h-2.142V18h2.142v2.143zm4.286 0H18V18h2.143v2.143zM5.146 18H3.003v-2.143h2.143V18zm4.285 0H7.288v-2.143h2.143V18zm4.284 0h-2.143v-2.143h2.143V18zM18 18h-2.143v-2.143H18V18z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarFileIcon);
export default __webpack_public_path__ + "static/media/tar-file-icon.a6be30ea75829fa3bb1308a6bdad93ef.svg";
export { ForwardRef as ReactComponent };